import React from 'react'
import {getFetcher, postFetcher, wrapLazy} from '@startlibs/utils'

let authenticated = process.env.NODE_ENV !== 'development'

export const lazyDevLogin = wrapLazy(() => {
  if (!authenticated) {
    const formData = new FormData()
    // formData.append('txtUserId', 'alfetunes')
    // formData.append('txtPassword', 'Purview2019!') //pixcloud
    // formData.append('txtPassword', 'sZWk7A2aLU') // vivacloud

    // formData.append('txtUserId', 'admin')
    // formData.append('txtPassword', 'admin') // vivacloud

    // formData.append('txtUserId', 'gmonteiro2022')
    // formData.append('txtPassword', 'sROib0qxoQ')
    
    // "password": "admin",
    // "rememberMe": true,
    // "username": "admin"
    // formData.append('txtUserId', 'purview@pacsdbue2testpi')
    // formData.append('txtPassword', 'Prob404!?')

    formData.append('txtUserId', 'gmonteiro+1@purview.net')
    formData.append('txtPassword', 'Purview#2024')
    formData.append('accept_cookies', 'on')
    formData.append('btnLogin', 'Login')

    return postFetcher('/viva', formData)
      .catch(() => authenticated = true)
  } else {
    return Promise.resolve()
  }
})